export default {
  textToShow: 'Importing in progress. This may take about 30 seconds.',
  animate: true,
  show: true,
  showTimer: true,
  time: 200,
};
